import _Toast from './ToastPlugin';

import './style/index.js';

export * from './type';

export const toast = _Toast;

export default toast;
